var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHistoryBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Interface / History",
    clipPath: "url(#clip0_2819_206832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 23 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4151 36.9324C9.6829 37.6647 9.6829 38.8518 10.4151 39.5841C18.4697 47.6386 31.5287 47.6386 39.5833 39.5841C47.6378 31.5295 47.6378 18.4705 39.5833 10.4159C31.5287 2.36136 18.4697 2.36136 10.4151 10.4159C6.38586 14.4452 4.37186 19.7307 4.37421 25.0092L4.37417 29.1666C4.37416 30.2022 5.21362 31.0417 6.24916 31.0417C7.28469 31.0417 8.12416 30.2022 8.12417 29.1667L8.12421 25.0093C8.12209 20.6849 9.76925 16.3651 13.0668 13.0676C19.6569 6.47748 30.3415 6.47748 36.9316 13.0676C43.5217 19.6577 43.5217 30.3423 36.9316 36.9324C30.3415 43.5225 19.6569 43.5225 13.0668 36.9324C12.3345 36.2002 11.1474 36.2002 10.4151 36.9324Z",
    fill: "#0082CD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 69 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24996 26.515L3.40912 23.6742C2.67689 22.9419 1.4897 22.9419 0.757471 23.6742C0.0252374 24.4064 0.0252362 25.5936 0.75747 26.3258L4.92413 30.4925C5.27576 30.8441 5.75267 31.0417 6.24995 31.0417C6.74723 31.0417 7.22415 30.8441 7.57578 30.4925L11.7424 26.3258C12.4747 25.5936 12.4747 24.4064 11.7424 23.6742C11.0102 22.9419 9.82303 22.9419 9.0908 23.6742L6.24996 26.515Z",
    fill: "#0082CD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 70 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.917 14.7917C21.8815 14.7917 21.042 15.6312 21.042 16.6667L21.042 27.0834C21.042 28.1189 21.8815 28.9584 22.917 28.9584L33.3337 28.9584C34.3692 28.9584 35.2087 28.1189 35.2087 27.0834C35.2087 26.0479 34.3692 25.2084 33.3337 25.2084L24.792 25.2084L24.792 16.6667C24.792 15.6312 23.9525 14.7917 22.917 14.7917Z",
    fill: "#0082CD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2819_206832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryBig);
export default __webpack_public_path__ + "static/media/history-big.ee4c41200ffec10721e57372edefa87f.svg";
export { ForwardRef as ReactComponent };